import { useEffect, useState } from "react";
import { Box, Flex, Icon, Text } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import { useMeasure } from "react-use";
import {
  ArrowDown,
  ArrowUp,
  Checkmark,
  Minus,
  Plus,
} from "~components/common/Icons";
import { MenuAccordion } from "~components/common/Navigation/components/MenuAccordion";

export const CategoriesAccordion = ({ categories }) => {
  const router = useRouter();
  const [ref, { height }] = useMeasure();
  const [openItem, setOpenItem] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const tagsHandler = (check: boolean, value: string) => {
    if (check) {
      const route = { query: { ...router.query, category: "" } };
      router.push(route, undefined, { shallow: true });
    } else {
      const route = { query: { ...router.query, category: value } };
      router.push(route, undefined, { shallow: true });
    }
  };
  const count = router?.query?.category ? 1 : 0;
  useEffect(() => {
    if (router.isReady && count) {
      const index = categories.findIndex(([_, item]) =>
        item.find(({ id }) => id === Number(router?.query?.category))
      );
      if (index !== -1) setOpenItem(index);
    }
  }, [router.isReady]);
  return (
    <Box mb={2} backgroundColor={"#EEE3D7"} borderRadius={"8px"} px={2}>
      <Box>
        <Flex
          justifyContent="space-between"
          alignItems="flex-start"
          py={2}
          borderBottom={isOpen && "1px solid #FFFFFF99"}
          cursor="pointer"
          onClick={() => setIsOpen((open) => !open)}
        >
          <Flex alignItems={"center"} position={"relative"}>
            <Text fontSize={"18px"} fontFamily={"DINPro"} fontWeight="500">
              Categorieën
            </Text>
            {!!count && (
              <Box
                ml={1}
                fontSize={"10px"}
                fontWeight={700}
                lineHeight={"15px"}
                textAlign={"center"}
                fontFamily={"DINPro"}
                width={16}
                height={16}
                backgroundColor={"#C39A91"}
                borderRadius={"full"}
              >
                {count}
              </Box>
            )}
          </Flex>
          <Flex>
            <Icon icon={!isOpen ? Plus : Minus} fontSize={"20px"} />
          </Flex>
        </Flex>
        <Box
          maxHeight={
            isOpen ? [`${height + 3 * 8}px`, `${height + 4 * 8}px`] : 0
          }
          transition="max-height ease 0.3s"
          overflow="hidden"
        >
          <Box
            mt={isOpen ? [1, "4px"] : 0}
            pb={[0, "4px"]}
            transition="opacity ease 0.25s"
            opacity={isOpen ? 1 : 0}
            ref={ref}
          >
            {categories.map(([title, items], i) => (
              <Box
                key={title}
                onClick={(e) => {
                  if (i === openItem) setOpenItem(null);
                  else setOpenItem(i);
                  e.stopPropagation();
                }}
              >
                <MenuAccordion
                  key={title}
                  title={title}
                  isNoBorder={i === categories.length - 1}
                  isTags
                  IsOpen={i === openItem}
                >
                  <Box>
                    {items
                      .sort((a, b) =>
                        a.category_name > b.category_name ? 1 : -1
                      )
                      .map(({ category_name, id }, i) => {
                        const check = router?.query?.category === String(id);
                        return (
                          <Box
                            onClick={(e) => {
                              e.stopPropagation();
                              tagsHandler(check, id);
                            }}
                            mt="11px"
                            display="flex"
                            key={id}
                            cursor={"pointer"}
                            width={"100%"}
                          >
                            <Box
                              width="20px"
                              height="20px"
                              borderRadius="4px"
                              border="1px solid grey200"
                              backgroundColor="white"
                              mr={"10px"}
                              flexShrink={0}
                              cursor="pointer"
                            >
                              {check && (
                                <Icon
                                  display={check && "none"}
                                  icon={Checkmark}
                                  fontSize="14px"
                                  ml={"2px"}
                                />
                              )}
                            </Box>

                            <Text
                              overflow="hidden"
                              whiteSpace="nowrap"
                              fontWeight={400}
                              fontSize="16px"
                              css={{
                                textOverflow: "ellipsis",
                                textTransform: "capitalize",
                              }}
                            >
                              {category_name}
                            </Text>
                          </Box>
                        );
                      })}
                  </Box>
                </MenuAccordion>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
